import { useEffect, useState } from "react";

/**
 * GrainOverlay - Subtle film grain texture for premium aesthetic
 * Adds tactile warmth to digital surfaces
 */
export const GrainOverlay = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);
    
    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  if (prefersReducedMotion) return null;

  return <div className="grain-overlay" aria-hidden="true" />;
};
